import base64toBlob from "utils/base64toBlob";
import { arrayBufferToBase64 } from "utils/bufferToBase64";
import { fixZip } from "utils/turbowarp-sb3fix";

/**
 * Function used to transform the file coming from Scratch into
 * a base64 file
 * @param event
 * @returns
 */
const processFileFromScratch = (
  event: MessageEvent,
): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    // Process the file into base64
    const reader = new FileReader();
    reader.readAsDataURL(event.data.json);
    reader.onloadend = async () => {
      const base64File = reader.result;

      // Check if the file is defined appropriately
      if (!base64File) return resolve(null);

      try {
        // Make sure that there is no bug in this file
        // 1. Transform the file into a blob
        const blobFile = base64toBlob(base64File as string);
        // 2. Apply the fixing process
        const fileFixed = await fixZip(blobFile);
        // 3. Come back to base64
        const base64FileCleaned = arrayBufferToBase64(fileFixed);
        // 4. Wrap it into a base64 header
        const fileOutput = `data:application/x.scratch.sb3;base64,${base64FileCleaned}`;
        // And return
        resolve(fileOutput);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => reject(reader.error);
  });
};

export default processFileFromScratch;
